import { useComponentTexts, useValidationTexts } from "Store/texts/hooks";

import { WrapMdMarginBottom } from "App/global-style";
import { ContactUsAlert } from "Components/Form/Alert";
import { NumericInput } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { isContentsInsuranceSumTooHigh } from "../../CabinContents/cabinContentsConditions";

interface ContentsInsuranceSum {
  contentsInsuranceSum?: number;
}

interface Props<T extends ContentsInsuranceSum = ContentsInsuranceSum> {
  formProps: FormikProps<T>;
  lang: TextLanguage;
}

export const InsuranceSumInput = ({
  formProps,
  lang,
}: Props): React.ReactElement => {
  const [
    {
      formComponentsCabinProducts: { insuranceSum },
    },
  ] = useComponentTexts();
  const [{ alertTitle }] = useValidationTexts();

  return (
    <>
      <NumericInput
        name="contentsInsuranceSum"
        id="contentsInsuranceSum"
        large
        label={insuranceSum.label[lang]}
        hint={insuranceSum.hint[lang]}
        inputMode={InputMode.NUMERIC}
        error={getError("contentsInsuranceSum", formProps)}
        inputProps={{ autoComplete: "off" }}
      />
      {isContentsInsuranceSumTooHigh(formProps.values.contentsInsuranceSum) && (
        <WrapMdMarginBottom>
          <ContactUsAlert
            description={insuranceSum.validation.tooHigh[lang]}
            title={alertTitle[lang]}
            alertId="contentsInsuranceSumTooHigh"
          />
        </WrapMdMarginBottom>
      )}
    </>
  );
};
